import { Component, OnInit, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { map, takeUntil } from 'rxjs/operators';
import { environment, GINConstants } from '../environments/environments';
import { throwError } from 'rxjs';

import { io, Socket } from 'socket.io-client';
@Injectable({
  providedIn: 'root'
})
export class ApidataService {
  observer1: any;

  constructor(private _https: HttpClient, private router: Router) {

  }

  ////////// socket funtions

  private url = environment.API_URL + '';
  private socket1: Socket;
  private myObjStr1;

  saveDataDoOperationsReq(profile_id, doc_url, title, contents, do_grammar_check, new_testing) {
    var date = new Date();
    var time = date.toLocaleTimeString();

    this.socket1.emit('saveDataCorrectContents', { 'profile_id': profile_id, 'doc_url': doc_url, 'docTitle': title, 'docContents': contents, 'do_grammar_check': do_grammar_check, 'new_testing': new_testing });
    //  console.log("eeeeeeeeeee")

  }
  public addRuleReport(profile_id, rule_name, doc_id, sentence) {
    //  console.log(profile_id, rule_name, doc_id);
    let data2 = JSON.stringify({ profile_id: profile_id, rule: rule_name, doc_id: doc_id, sentence: sentence });

    return this.postResources(data2, environment.API_URL + '/api/addReportedRule');
  }
  // ##################################################################################################################################
  saveDataDoOperationsRes() {

    let observable1 = new Observable(observer1 => {
      this.socket1 = io(this.url, { query: { 'Authorization': 'Bearer NzBkMjM3NTFiZGEzODYxOTgxOTAmMjI2OTNtYTNj' } });
      //  console.log(this.socket1, 'sockettttttttttt')
      this.socket1.on('saveDataCorrectContents', (data1) => {
        this.myObjStr1 = JSON.stringify(data1);
        observer1.next(data1);
      });

      return () => {
        if (!this.myObjStr1) {
          this.socket1.disconnect();
        }

      };
    })
    return observable1;
  }
  disconnected_Socket() {
    this.socket1.disconnect();
  }
  // Ensure socket connection is initialized
  initializeSocketConnection() {
    if (!this.socket1) {
      this.socket1 = io(this.url, { query: { 'Authorization': 'Bearer NzBkMjM3NTFiZGEzODYxOTgxOTAmMjI2OTNtYTNj' } });
      this.listenForSocketEvents(); // Moved event listeners here
    }
  }

  // Listen for socket events
  listenForSocketEvents() {
    this.socket1.on('checkChunkContent', (data1) => {
      //  console.log(data1, "chunk response");
      this.myObjStr1 = JSON.stringify(data1);
      this.observer1?.next(data1); // Use optional chaining to avoid errors
    });
  }

  // Method to send data
  saveDataDoOperationsReqchunk(profile_id, doc_url, contents, ChkiD) {
    this.initializeSocketConnection(); // Ensure socket is initialized
    //  console.log(contents, ChkiD, 'sending to socket');
    this.socket1.emit('checkChunkContent', {
      'profile_id': profile_id,
      'doc_url': doc_url,
      'docContents': contents,
      'ChkiD': ChkiD,
    });
  }

  // Method to observe responses
  saveDataDoOperationsReschunk() {
    return new Observable(observer1 => {
      this.observer1 = observer1; // Store observer reference
      this.initializeSocketConnection(); // Ensure socket is initialized
      // The socket listener has been moved to `listenForSocketEvents()` for clarity

      return () => {
        if (!this.myObjStr1) {
          this.socket1.disconnect();
        }
      };
    });
  }

  public generateReadabilityReport(data: Record<string, any>) {
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });

    return this._https.post<any>(environment.API_URL + '/processingGrammarReport', data, { headers }).pipe(
      map(response => response)
    );
  }

  public aiAssistantApiRequest(formData: FormData, profile_id) {
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });

    return this._https.post<any>(
      environment.API_URL + '/api/aiAssistant',
      {
        text: formData.get('text'),
        user_id: profile_id,
      },
      { headers: headers }
    );
  }

  public aiContentDetection(user_id, status: string, text: string) {
    const data = { text, user_id, status };

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });

    return this._https.post<any>(environment.API_URL + '/api/aiProcessing', data, { headers }).pipe(
      map(response => response)
    );
  }

  public plagiarismChecker(user_id, status: string, text: string) {
    const data = { text, user_id, status, access_token: 'KW#2TI7G30fA(V' };

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });


    return this._https.post<any>(environment.API_URL + '/api/plagProcessing', data, { headers }).pipe(
      map(response => response)
    );
  }





  ///////// end socket functions

  ///// error fix all api
  fixallAPI(str: string, lang: string, filters, ChkiD): Observable<any> {
    // checkgrammarModel   for model
    // checkgrammar  for both
    const data = { text: str, language: lang, filters, ChkiD };

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });

    return this._https.post<any>(environment.API_URL + '/api/fixallAPI', data, { headers }).pipe(
      map(response => response)
    );
  }
  resentcodeforaccount(profile_id): Observable<any> {
    // checkgrammarModel   for model
    // checkgrammar  for both
    const data = { user_id: profile_id };

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });

    return this._https.post<any>(environment.API_URL + '/api/resendCode', data, { headers }).pipe(
      map(response => response)
    );
  }

  //// end fix all api

  public isAuthenticatedVerificationSimple() {
    return this.isAuthenticated();
  }
  public isAuthenticated() {
    return !this.checkTokenExpired();
  }
  public clearUserDataAndRedirect() {
    localStorage.clear();
  }
  private checkTokenExpired() {

    let expiryTime = Number(localStorage.getItem('token_age') || JSON.parse(localStorage.getItem('currentUser')));
    let curTime = new Date().getTime();

    if (curTime > expiryTime) {
      //  console.log(curTime + ' -- ' + expiryTime);
      return true;
    }
    return false;
  }

  public postResource(body: string, url: string): Observable<any> {
    let headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, 'Content-Type': 'application/json' });

    if (this.isAuthenticated()) {
      const token = localStorage.getItem('token');
      headers = headers.set('Authentication-Token', token);
    }

    return this._https.post<any>(url, body, { headers });
  }

  onloadcontentresquest(profile_id: string, doc_url: string): Observable<any> {
    const token = localStorage.getItem('token');
    const data = { 'profile_id': profile_id, 'doc_url': doc_url, 'create_chunks': '' };
    //  console.log(profile_id, 'profile id');

    let headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN
    });

    if (profile_id !== '1') {
      headers = headers.set('Authentication-Token', token || '');
    }

    return this._https.post<any>(environment.API_URL + '/api/getDocContentsByDocID', data, { headers }).pipe(
      map(response => response)
    );
  }
  break_sentence_mobile(txt, doc_id): Observable<any> {
    const data = { content: txt, doc_id: doc_id }

    // const headers = new HttpHeaders({
    //   'Authorization': 'Bearer ' + '2685bb3a2ffc6eabccc3b6ebbfee886cd2d7061e',
    // });
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, });
    return this._https.post<any>(environment.API_URL + '/api/processing', data, { headers }).pipe(
      map(response => response)
    );
  }

  grammarcheckerapi_mobile(str: string, lang: string, filters, ChkiD, doc_id, batch, node_name): Observable<any> {
    // checkgrammarModelNew   for model
    // checkgrammar  for both
    const data = { text: str, language: lang, filters, ChkiD, doc_id, batch, node_name };
    //  console.log(data, 'sending data')
    // const headers = new HttpHeaders({
    //   'Authorization': 'Bearer ' + '2685bb3a2ffc6eabccc3b6ebbfee886cd2d7061e',
    // });
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, });

    return this._https.post<any>(environment.API_URL + '/api/stillProcessing', data, { headers }).pipe(
      map(response => response)
    );
  }


  public sentence_send_api5(content, profile_id, doc_url, ChkiD): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, });
    let data = JSON.stringify({ content: content, profile_id: profile_id, doc_url: doc_url, ChkiD: ChkiD });
    return this._https.post(data, environment.API_URL + '/api/stillProcessing', { headers });
  }
  editor_sentence_breakapi(content: string): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, });
    return this._https.post<any>(environment.API_URL + '/api/processing', { content }, { headers });
  }
  break_sentence(
    batch,
    txt,
    doc_id,
    filters,
    profile_id?: any,
    language?: string,
    cancelSignal?: Subject<void>
  ): Observable<any> {
    profile_id = profile_id ?? 1;
    const data = { batch, content: txt, doc_id: doc_id, filters, profile_id: profile_id, language };

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + '2685bb3a2ffc6eabccc3b6ebbfee886cd2d7061e',
    });

    const abortSignal = cancelSignal ?? new Subject<void>();

    return this._https
      .post<any>(environment.API_URL + '/api/dataProcessing', data, {
        headers,
      })
      .pipe(
        takeUntil(abortSignal),
        map((response) => response)
      );
  }
  grammarcheckerapi(
    str: string,
    lang: string,
    filters,
    ChkiD,
    doc_id,
    batch,
    node_name,
    cancelSignal?: Subject<void>
  ): Observable<any> {
    // checkgrammarModelNew   for model
    // checkgrammar  for both
    const data = {
      text: str,
      language: lang,
      filters,
      ChkiD,
      doc_id,
      batch,
      node_name,
    };
    //  console.log(data, 'sending data')
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + '2685bb3a2ffc6eabccc3b6ebbfee886cd2d7061e',
    });

    const abortSignal = cancelSignal ?? new Subject<void>();

    return this._https
      .post<any>(
        environment.API_URL + '/api/resultsProcessing',
        data,
        { headers }
      )
      .pipe(
        takeUntil(abortSignal),
        map((response) => response)
      );
  }
  toneDetectorAPI(
    text,
    language,
    filters,
    ChkiD,
    doc_id,
    batch,
    node_name,
    cancelSignal?: Subject<void>
  ): Observable<any> {
    const data = {
      text,
      language,
      filters,
      ChkiD,
      doc_id,
      batch,
      node_name,
      tone_detect: true,
    };

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });

    const abortSignal = cancelSignal ?? new Subject<void>();

    return this._https
      .post<any>(environment.API_URL + '/api/tonedetection', data, {
        headers,
      })
      .pipe(
        takeUntil(abortSignal),
        map((response) => response)
      );
  }

  updateShowTargetsOnLoad(show_targets, profile_id): Observable<any> {
    var data = { show_targets, profile_id };
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
      'Authentication-Token': localStorage.getItem('token'),
    });
    return this._https.post<any>(environment.API_URL + '/api/update_targets', data, { headers }).pipe(map(response => response))
  }

  uploadfilefrombrowser(file): Observable<any> {
    const formdata: FormData = new FormData();
    formdata.append('file', file[0], file[0].name);
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post<any>(environment.API_URL + '/api/uploadFile', formdata, { headers }).pipe(map(response => response))
  }
  dropboxfile(filetype, fileurl): Observable<any> {
    var data = { 'file_type': filetype, 'file_path': fileurl };
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post<any>(environment.API_URL + '/api/uploadFromDropBox', data, { headers }).pipe(map(response => response))
  }
  feedbackapi(emotion, text): Observable<any> {
    var data = { 'emotion': emotion, 'comment': text };
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post<any>(environment.API_URL + '/api/feedbackForm', data, { headers }).pipe(map(response => response))
  }
  articleapi(text, cancelSignal?: Subject<void>) {
    var data = { 'text': text };

    const abortSignal = cancelSignal ?? new Subject<void>();

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    //  console.log(text, 'serviceeeeeeee')
    return this._https.post(environment.API_URL + '/api/rewritingArticle', data, { headers }).pipe(
      takeUntil(abortSignal),
      map(response => response)
    )
  }
  textsummarizerapi(text, percent, mode, cancelSignal?: Subject<void>) {
    var data = { 'text': text, 'percent': percent, "mode": mode };

    const abortSignal = cancelSignal ?? new Subject<void>();

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post(environment.API_URL + '/api/textSummarize', data, { headers }).pipe(
      takeUntil(abortSignal),
      map(response => response)
    )
  }
  // textstatusapi(requesthash, requestid ){
  //   var data = {'request-hash': requesthash, 'request-id': requestid};
  //   const headers = new HttpHeaders({
  //     'Authorization': environment.AuthorizationGIN,
  //   });
  //   return this._https.post(environment.API_URL+'/api/summarizerStatus', data, {headers}).pipe(map(response => response))
  // }
  aidetectorapi(text) {
    var data = { 'text': text };
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post(environment.API_URL + '/api/aiDetecttion', data, { headers }).pipe(map(response => response))
  }

  parapharsapi(text, lang, mode, cancelSignal?: Subject<void>) {
    var data = { 'text': text, 'lang': lang, 'mode': mode };

    const abortSignal = cancelSignal ?? new Subject<void>();

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post(environment.API_URL + '/api/paraphrazerSubmitText', data, { headers }).pipe(
      takeUntil(abortSignal),
      map(response => response)
    )
  }
  parapharsstatus(requesthash, requestid, mode, cancelSignal?: Subject<void>) {
    var data = { 'request-hash': requesthash, 'request-id': requestid, 'mode': mode };

    const abortSignal = cancelSignal ?? new Subject<void>();

    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post(environment.API_URL + '/api/paraphrazerStatus', data, { headers }).pipe(
      takeUntil(abortSignal),
      map(response => response))
  }
  contactus(first_name, last_name, email, subject, message): Observable<any> {
    var data = { 'first_name': first_name, 'last_name': last_name, 'email': email, 'subject': subject, 'message': message };
    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post<any>(environment.API_URL + '/api/contactForm', data, { headers }).pipe(map(response => response))
  }
  public postResources(body: string, url: string) {
    //  console.log(body, url, 'postresources')
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authentication-Token': token || '',
      'Authorization': environment.AuthorizationGIN,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
    });

    return this._https.post(url, body, { headers });
  }
  public filterallcategory(profile_id, doc_url, filterstatus): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, });
    let data = JSON.stringify({ user_id: profile_id, doc_url: doc_url, filterstatus: filterstatus });
    return this._https.post(data, environment.API_URL + '/api/getuserfilters', { headers })
  }
  public filtercustmoizedresponse(user_id, doc_id, filter, filterstatus): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, });
    let data = JSON.stringify({ user_id: user_id, doc_url: doc_id, filters: filter, filterstatus: filterstatus });
    return this._https.post(data, environment.API_URL + '/api/updateuserfilters', { headers });
  }


  passwordReset(fp_email): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, });
    return this._https.post<any>(environment.API_URL + '/api/resetPassword', { fp_email }, { headers })

  }

  confirmEmail(conf_code: string): Observable<any> {
    // let data = JSON.stringify({conf_code  });
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, 'Content-Type': 'application/json' });
    return this._https.post<any>(environment.API_URL + '/api/accountConfirm', { conf_code }, { headers })
  }
  confirmEmailPhone(conf_code: string): Observable<any> {
    // let data = JSON.stringify({conf_code  });
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, 'Content-Type': 'application/json' });
    return this._https.post<any>('https://api3.grammarin.com/api/accountConfirm', { conf_code }, { headers })
  }

  change_password(reset_password_code, new_password): Observable<any> {
    const headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, });
    return this._https.post<any>(environment.API_URL + '/api/updateUserForgotPassword', { reset_password_code, new_password }, { headers })

  }
  public auto_saved_Api(profile_id, file_name, docTitle, contents, doc_id1, saved_from): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id, file_name: file_name, docTitle: docTitle, contents: contents, doc_id: doc_id1, saved_from: saved_from });
    return this.postResource(data2, environment.API_URL + '/api/saveDocbyProfileIDusingDocID');
  }
  public auto_saved_Api1(profile_id, file_name, docTitle, contents, doc_id1, saved_from): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id, file_name: file_name, docTitle: docTitle, contents: contents, doc_id: doc_id1, saved_from: saved_from });
    return this.postResource(data2, environment.API_URL + '/api/saveDocbyProfileIDusingDocID');
  }
  public login(body: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'Application/json', 'Authorization': environment.AuthorizationGIN, });
    return this._https.post(environment.API_URL + '/api/userLogin', body, { headers })
      .pipe(map(this.extractToken))
  }
  public getUserProfileContents(profile_id): Observable<any> {
    // const headers = new HttpHeaders({  'Content-Type' : 'Application/json', 'Authorization': environment.AuthorizationGIN, });
    let data2 = JSON.stringify({ profile_id: profile_id });
    this.postResource(data2, environment.API_URL + '/api/getUserProfileContents').subscribe(
      (data) => { }
      , (error) => {
        // console.log(error, "401 ERROR")
        localStorage.clear();
        this.router.navigate(['/signin'])

        // alert("An unexpected error occurred: " + error.message);
      }
    )
    return this.postResource(data2, environment.API_URL + '/api/getUserProfileContents');
  }
  private extractToken(res: any): any {
    //  console.log(res['response']['response']);
    let body = res;
    //  console.log(body, 'what is json body?')
    //  console.log(body['code']);
    //  console.log(body['meta'].code);
    //  console.log(body.response['meta']['code']);
    let checktoken = body['response']['response'];
    //   console.log(checktoken.user.authentication_token)
    // let meta_code2 = body.code;
    let meta_code = body.code;
    //   console.log(body.response['meta']['code'], 'auth code')
    //  console.log(meta_code);
    if ((body.response['meta'].code === 200 || body.code)) {
      let response = 'response';
      let user = 'user';
      let userId = 'id';
      let first_name = 'first_name';
      let last_name = 'last_name';
      let first_name2 = 'firstname'

      let tokenString = checktoken.user.authentication_token;
      localStorage.setItem(checktoken.user.authentication_token, 'authentication_token');
      // alert(checktokenval)
      let token = checktoken.user.authentication_token;
      let profile_id = body[response][response][user][userId];
      let name = body[response][response][user]['verify'];
      //  console.log(profile_id, 'id');
      //  console.log(token)
      // alert(profile_id)
      let firstname = body[response][response][user][first_name];
      let lastname = body[response][response][user][last_name];
      //  let authentication_token = checktoken.user.authentication_token;
      //  alert(authentication_token)
      //  localStorage.setItem(authentication_token , 'authentication_token')
      // console.log(body, "BODY")
      let maxTokenExpiryTime = new Date().getTime() + (Number(body['response']['response']['user']['token_age']) * 1000);
      localStorage.setItem('fullname', name);
      localStorage.setItem('first_name', firstname);
      localStorage.setItem('last_name', lastname);
      localStorage.setItem('profile_id', profile_id);
      localStorage.setItem('token', token);
      localStorage.setItem('token_age', String(maxTokenExpiryTime));
      // localStorage.setItem('email', String(maxTokenExpiryTime));
    }
    //  if ( meta_code === 400 || body.code === 400 || body.code === 401) {
    //   //  console.log("400 code");
    // }
    return body;
  }
  //////// log out
  public logout() {
    if (this.isAuthenticated()) {
      this.postResource('', environment.API_URL + '/api/logoutuser')
        .subscribe(
          (data) => {
            this.handleLogout(data);
          },
          (error) => {
            if (error.status === 401) {
              this.router.navigate(['/']);
              // this.router.navigate(['/session-expired']);
            }
          },
          () => {
            // Optional: any cleanup or additional logic after the observable completes
            //  console.log('Logout request completed');
          }
        );
    } else {
      this.clearUserDataAndRedirect();
    }
  }
  private handleLogout(data: Response) {
    if (data.status === 200) {
      localStorage.clear();
      window.location.href = '';
    }
  }
  ///////// check is user login?
  public isLoggedIn() {
    if (!this.isAuthenticated()) {
      return false;
    } else {
      return true;
    }
  }
  // public signupinfb(body: string) {
  //   return this.postResource(environment.API_URL+'/api/signupinFacebookTesting', body, jsonHeader())
  // }
  ///////open files
  public getUserFilesListing(profile_id): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id });
    return this.postResource(data2, environment.API_URL + '/api/getDocumentsListing');
  }
  public getDocContentsByDocID(profile_id, doc_id): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id, doc_id: doc_id });
    return this.postResource(data2, environment.API_URL + '/api/getDocDataByProfileDocID');
  }
  public deleteDocumentByID(profile_id, doc_id): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id, doc_id: doc_id });
    return this.postResource(data2, environment.API_URL + '/api/deleteDocumentByID');
  }
  public updateProfileContents(profile_id, firstname): Observable<any> {
    let token = localStorage.getItem('authentication_token');
    let headers1 = new Headers({ 'Authentication-Token': token, 'Content-Type': 'application/json', 'Authorization': environment.AuthorizationGIN, 'Access-Control-Allow-Origin': '*', "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT" });
    let data2 = JSON.stringify({ profile_id: profile_id, firstname: firstname });
    return this.postResource(data2, environment.API_URL + '/api/updateProfileContents');
  }
  public updateUserPassword(user_id, current_password, new_password1, update_password,): Observable<any> {
    let data2 = JSON.stringify({ user_id: user_id, current_password: current_password, new_password1: new_password1, section: update_password });
    return this.postResource(data2, environment.API_URL + '/api/updateUserPassword');
  }
  public getPreferredLangByProfileID(profile_id): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id });
    return this.postResources(data2, environment.API_URL + '/api/getPreferredLangByProfileID');
  }
  public updateUserLanguage(profile_id, pref_language): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id, pref_language: pref_language });

    return this.postResources(data2, environment.API_URL + '/api/updateUserLanguage');
  }
  public getAllDictionaryWords(profile_id, auth_token?): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id });
    let data = { profile_id }
    let headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN, 'Authentication-Token': auth_token,
      'Content-Type': 'application/json'
    });

    return this._https.post<any>(environment.API_URL + '/api/getAllDictionaryWords', data, { headers });

  }

  public deleteDictWordByID(profile_id, dic_id): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id, dic_id: dic_id });
    return this.postResource(data2, environment.API_URL + '/api/deleteDictWordByID');
  }
  public toggleDictionaryByProfileID(profile_id, dictionaryStatus): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id, dictionaryStatus: dictionaryStatus });
    return this.postResource(data2, environment.API_URL + '/api/toggleDictionaryByProfileID');
  }
  public addDictionaryWord(profile_id, pdict_word): Observable<any> {
    let data2 = JSON.stringify({ profile_id: profile_id, pdict_word: pdict_word });
    return this.postResource(data2, environment.API_URL + '/api/addDictionaryWord');
  }
  public accountsettingcategory(profile_id, filterstatus): Observable<any> {
    let data = JSON.stringify({ user_id: profile_id, filterstatus: filterstatus });
    return this.postResource(data, environment.API_URL + '/api/getuserfiltersAccount');
  }
  public callpaymentapi(profile_id, price_id): Observable<any> {
    let data2 = JSON.stringify({ user_id: profile_id, price_id: price_id, });
    return this.postResource(data2, environment.API_URL + '/api/getCheckoutURL')
  }

  public downloadpdfpaymentinvoice(invoice_id: string, user_id): Observable<Blob> {
    let data = JSON.stringify({ invoice_id: invoice_id, user_id: user_id });
    const url = environment.API_URL + `/api/getinvoice`;
    return this.postResourcess(url, data,);
  }

  public postResourcess(url: string, body: any): Observable<Blob> {
    let headers = new HttpHeaders({ 'Authorization': environment.AuthorizationGIN, 'Content-Type': 'application/json' });

    if (this.isAuthenticateds()) {
      const token = localStorage.getItem('token');
      headers = headers.set('Authentication-Token', token);
    }

    return this._https.post(url, body, { headers, responseType: 'blob' });
  }

  private isAuthenticateds(): boolean {
    return !!localStorage.getItem('token');
  }
  public isAuthenticatedd(): boolean {
    return !!localStorage.getItem('token');
  }


  public isAuthenticatedss(): boolean {
    return !!localStorage.getItem('token');
  }
  public signupinGoogle2(body: any): Observable<any> {
    const data = JSON.stringify(body);
    //  console.log(data, 'what is data ')
    return this.postResource(data, environment.API_URL + '/api/signupinGoogleTesting');
  }

  public signupinfb(body: string) {

    const data = JSON.stringify(body);
    return this.postResource(data, environment.API_URL + '/api/signupinFacebookTesting');
  }
  private extractToken2(res: Response) {
    // console.log(res);
    let body = res.json();
    //  console.log(body);
    let meta_code = body['meta']['code'];

    //  console.log(meta_code);
    if (res.status === 200 && meta_code === 200) {
      let response = 'response';
      let user = 'user';
      let userId = 'id';
      let first_name = 'first_name';
      let last_name = 'last_name';
      let first_name2 = 'firstname'

      let tokenString = 'authentication_token';
      localStorage.setItem('authentication_token', 'authentication_token')
      let token = body[response][user][tokenString];
      let profile_id = body[response][user][userId];

      let firstname = body[response][user][first_name];
      let lastname = body[response][user][last_name];
      let authentication_token = body[response][user]['authentication_token'];
      localStorage.setItem('authentication_token', 'authentication_token')
      let maxTokenExpiryTime = new Date().getTime() + (Number(body['response']['response']['user']['token_age']) * 1000);
      localStorage.setItem('first_name', firstname);
      localStorage.setItem('last_name', lastname);
      localStorage.setItem('profile_id', profile_id);
      localStorage.setItem('token', token);
      localStorage.setItem('token_age', String(maxTokenExpiryTime));
    } else if (res.status === 200 && meta_code === 400) {
      //  console.log("400 code");
    }
    return body;
  }

  public submitEFile(profile_id: string, files: File[], create_chunks: string): Observable<any> {
    const formData: FormData = new FormData();

    // Check if the files array is not empty and append the first file
    if (files.length > 0) {
      formData.append('file', files[0], files[0].name);
    }

    formData.append('profile_id', profile_id);
    formData.append('create_chunks', create_chunks);

    const getdocx = files[0].name.split('.');
    //  console.log(getdocx[1], 'first index');

    let headers = new HttpHeaders().set('Authorization', environment.AuthorizationGIN);

    if (this.isAuthenticatedss()) {
      const token = localStorage.getItem('token');
      headers = headers.set('Authentication-Token', token);
    }

    return this.postFileResource(formData, environment.API_URL + '/api/getNewDocIDbyProfileIDFileContents', headers);
  }

  public postFileResource(body: FormData, url: string, headers: HttpHeaders): Observable<any> {
    return this._https.post(url, body, { headers });
  }

  public getNewDocIDbyProfileIDusingFileNamenew(profile_id, file_name, docTitle, contents, doc_id1) {

    let data2 = JSON.stringify({ profile_id: profile_id, file_name: file_name, docTitle: docTitle, contents: contents, doc_id: doc_id1 });
    return this.postResource(data2, environment.API_URL + '/api/saveDocbyProfileIDusingDocID');
  }
  public submitEDocument(profile_id, doc_url, email_sub, email_body, attachment_type) {

    let data2 = JSON.stringify({ profile_id: profile_id, doc_url: doc_url, email_sub: email_sub, email_body: email_body, attachment_type: attachment_type });
    return this.postResource(data2, environment.API_URL + '/api/submitEDocument');
  }

  public submitSupportForm(profile_id, doc_id, form_subject, form_message, version) {
    let data2 = JSON.stringify({ profile_id: profile_id, doc_id: doc_id, form_subject: form_subject, form_message: form_message, version: version });
    return this.postResource(data2, environment.API_URL + '/api/submitSupportForm');
  }

  public pdf(doc_id) {
    // alert(doc_id)
    // let data2 = JSON.stringify({  doc_id: doc_id });

    return this._https.get(environment.API_URL + '/api/downloadPDFByDocId/' + doc_id, { responseType: 'blob' });
  }
  //// ignore fun post api
  public ignorewords(user_id, doc_url, word, offset) {
    let data2 = JSON.stringify({ user_id: user_id, doc_url: doc_url, word: word, offset: offset });
    return this.postResource(data2, environment.API_URL + '/api/addIgnoreWord');
  }
  /// ignored word get api
  public getignorewords(doc_url) {
    let data2 = JSON.stringify({ doc_url: doc_url, });
    return this.postResource(data2, environment.API_URL + '/api/ignoreWordList');
  }

  Humanizerapi(text) {
    var data = { 'text': text };



    const headers = new HttpHeaders({
      'Authorization': environment.AuthorizationGIN,
    });
    return this._https.post(environment.API_URL + '/api/aiHumanizer', data, { headers }).pipe(
      map(response => response)
    )
  }
}

function jsonHeader(): any {
  throw new Error('Function not implemented.');
}

